module.exports = __webpack_public_path__ + "img/am-pm-kosher-market.d7d6a609.png";